import canClockSegmentEntry from '@/mixins/clocking/individual/canClockSegmentEntry';
import constants from '@/constants';

export default {
  mixins: [canClockSegmentEntry],

  methods: {
    createSegmentClockOut(
      timePair,
      assignmentId = null,
      successCallBack,
      lastly = () => {},
      timeZoneOffset = null,
      locationRequired = false,
      errorResetCallback = () => {},
    ) {
      this.getBaseTimeEntryRequest(
        constants.EntryType.CLOCK_OUT,
        timeZoneOffset,
        locationRequired,
        assignmentId,
        null,
        (timeEntryRequest) => {
          timeEntryRequest.segmentTimePairId = timePair.id;

          this.postSegmentTimeEntry(timeEntryRequest, successCallBack, lastly, errorResetCallback);
        },
        lastly,
      );
    },
  },
};
